import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DisputeDetailsComponent } from '../dispute-details/dispute-details.component';
import { DisputeListComponent } from '../dispute-list/dispute-list.component';
import { DisputeComponent } from './dispute.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  {
    path: '',
    component: DisputeComponent,
    children: [{ path: '', component: DisputeListComponent, data: { title: 'Dispute List' } }],
  },
  {
    path: ':id',
    component: DisputeComponent,
    children: [
      { path: '', component: DisputeDetailsComponent, data: { title: 'Dispute Details' } },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisputeRoutingModule {}

@NgModule({
  imports: [
    DisputeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [DisputeComponent, DisputeListComponent, DisputeDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DisputeModule {}
